export enum InteractionName {
  FMP = 'first-meaningful-paint',
  LoadExperiments = 'load-experiments',
  LoadWidgetSettings = 'load-widget-settings',
  LoadPaymentMethods = 'load-payment-methods',
  PayPalLoadScript = 'paypal-load-script',
  PayPalCreateOrder = 'paypal-create-order',
  PayPalOnPaymentAuthorizedFetchData = 'paypal-on-payment-authorized-fetch-data',
  PayPalUpdateOrder = 'paypal-update-order',
  ApplePayLoadScript = 'apple-pay-load-script',
  ApplePayValidateMerchant = 'apple-pay-validate-merchant',
  GooglePayLoadOptions = 'google-pay-load-options',
  GooglePayOnPaymentAuthorizedLoadData = 'google-pay-on-payment-authorized-load-data',
}
export enum PhaseName {
  LoadMainBundle = 'load-main-bundle',
  LoadSettings = 'load-preload-data',
}
